import { Spin } from "antd";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { Suspense, useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import RouteGuard from "./core/guard/route.guard";
import { persistor, store } from "./core/store";
import { setScreenType } from "./core/store/reducers/settings.slice";
import { WEB_URL } from "./shared/constants";
import { msalConfig } from "./msalConfig";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = WEB_URL + "ckfinder/ckfinder.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <AppRouted />
          </Router>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
export function AppRouted() {
  const dispatch = useDispatch()
  const screenType = {
    isXl: useMediaQuery({ minWidth: 1201 }),
    isLg: useMediaQuery({ minWidth: 992, maxWidth: 1200 }),
    isMd: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    isSm: useMediaQuery({ minWidth: 576, maxWidth: 767 }),
    isXs: useMediaQuery({ maxWidth: 575 }),
    isPortrait: useMediaQuery({ query: '(orientation: portrait)' })
  }
  useEffect(() => {
    dispatch(setScreenType(screenType))
  }, [])
  return (
    <>
      <Suspense
        fallback={
          <div>
            <Spin />
          </div>
        }
      >
        <MsalProvider instance={msalInstance}>
        <Routes>
          <Route path="*" element={<RouteGuard />} />
        </Routes>
      </MsalProvider>
      </Suspense>
    </>
  );
}
